<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPresentationOff_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M2.244.636a.5.5 0 0 0-.707.707l.787.787A1.99 1.99 0 0 0 1 4v6a2 2 0 0 0 2 2h9.193l1.754 1.754a.5.5 0 0 0 .708 0 .5.5 0 0 0 0-.707zM3 10.5a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5h.694l6.999 7zm7.333 2.5H5.667l-.447 1.342a.5.5 0 0 0 .474.658h4.613a.5.5 0 0 0 .474-.658zM5.022 2H13a2 2 0 0 1 2 2v6c0 .547-.221 1.042-.576 1.403l-1.062-1.062A.5.5 0 0 0 13.5 10V4a.5.5 0 0 0-.5-.5H6.522z"
        clip-rule="evenodd"
    />
</svg>
